import React from 'react';
import { rst } from 'rt-state';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { TR, TRHtml } from '../../../commons';
import { ROUTES } from '../../../routes';

const useStyles = makeStyles((theme) => {
    return {
        button: {
            height: '46px',
            borderRadius: '10px',

            fontSize: '16px',
            fontFamily: theme.typography.fontFamily,
        },
        searchButton: {
            backgroundColor: '#1875f0',
            width: '110px',
            color: 'white',
        },
        modifyButton: {
            borderColor: theme.palette.primary.main,
            width: '170px',
            backgroundColor: 'white',
            color: theme.palette.primary.main,
        },

        searchDialogTitle: {
            fontSize: '24px',
        },
        searchDialogButton: {
            fontSize: '16px',
        },
        dummy: {},
    };
});
export const PopupComponent = rst.create((ctx: any) => {
    const state = rst.state({
        help: false,
    });
    function handleClick(isOpen: boolean) {
        state.help = isOpen;
        console.log('wo!!!!!');
    }
    function handleOpenMember(isOpen: boolean) {
        state.help = isOpen;
        window.open(`${ROUTES.JoinMember.path}`);
    }
    return (props: { content: string; link: string; maxWidth: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' }) => {
        const classes = useStyles(props);
        return (
            <span>
                {
                    <span
                        style={{
                            textDecoration: 'underline',
                            color: 'blue',
                            // fontSize: 14,
                            cursor: 'hand',
                        }}
                        onClick={() => handleClick(true)}>
                        <TR name={props.link} />
                    </span>
                }
                <Dialog
                    onClose={() => handleClick(false)}
                    aria-labelledby="customized-dialog-title"
                    open={state.help}
                    maxWidth={props.maxWidth}
                    fullWidth={true}>
                    <DialogTitle>
                        <TR name={'info'} />
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography gutterBottom>
                            <TRHtml html={props.content} />
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        {props.content === 'Expired_membership' ? (
                            <Button autoFocus onClick={() => handleOpenMember(false)} color="primary">
                                <TR name={'Pls_renew'} />
                            </Button>
                        ) : (
                            <Button autoFocus onClick={() => handleClick(false)} color="primary">
                                <TR name={'Get it'} />
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            </span>
        );
    };
});
export const PopupComponentGray = rst.create((ctx: any) => {
    const state = rst.state({
        help: false,
    });
    function handleClick(isOpen: boolean) {
        state.help = isOpen;
        console.log('wo!!!!!');
    }
    function handleOpenMember(isOpen: boolean) {
        state.help = isOpen;
        window.open(`${ROUTES.JoinMember.path}`);
    }
    return (props: { content: string; link: string; maxWidth: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' }) => {
        const classes = useStyles(props);
        return (
            <span>
                {
                    <span
                        style={{
                            textDecoration: 'underline',
                            color: '#AAAAAA',
                            // fontSize: 14,
                            cursor: 'hand',
                        }}
                        onClick={() => handleClick(true)}>
                        <TR name={props.link} />
                    </span>
                }
                <Dialog
                    onClose={() => handleClick(false)}
                    aria-labelledby="customized-dialog-title"
                    open={state.help}
                    maxWidth={props.maxWidth}
                    fullWidth={true}>
                    <DialogTitle>
                        <TR name={'info'} />
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography gutterBottom>
                            <TRHtml html={props.content} />
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        {props.content === 'Expired_membership' ? (
                            <Button autoFocus onClick={() => handleOpenMember(false)} color="primary">
                                <TR name={'Pls_renew'} />
                            </Button>
                        ) : (
                            <Button autoFocus onClick={() => handleClick(false)} color="primary">
                                <TR name={'Get it'} />
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            </span>
        );
    };
});
